'use client';

import { Box } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { Resizable } from 're-resizable';
import { useCallback, useState } from 'react';

import FilterSectionContent from '@features/marketplace/navigation/FilterSectionContent';
import {
  FILTER_SECTION_MAX_WIDTH_PX,
  FILTER_SECTION_MIN_WIDTH_PX,
} from 'config/layout/navigationPanel';
import { useBoolean } from 'hooks/useBoolean';

const FilterSection = () => {
  const [isResizing, setIsResizing] = useBoolean();
  const [navigationSidebarWidth, setNavigationSidebarWidth] = useState(FILTER_SECTION_MIN_WIDTH_PX);

  const setResizedWidth = useCallback(
    ({ widthChange }: { widthChange: number }) => {
      setNavigationSidebarWidth(navigationSidebarWidth + widthChange);
      setIsResizing.off();
    },
    [navigationSidebarWidth, setIsResizing],
  );

  return (
    <Resizable
      minWidth={FILTER_SECTION_MIN_WIDTH_PX}
      maxWidth={FILTER_SECTION_MAX_WIDTH_PX}
      size={{
        width: navigationSidebarWidth,
        height: '100%',
      }}
      onResizeStart={setIsResizing.on}
      onResizeStop={(_evt, _dir, _target, delta) => setResizedWidth({ widthChange: delta.width })}
      enable={{
        top: false,
        right: true,
        bottom: false,
        left: false,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false,
      }}
      style={{
        flexDirection: 'row',
        display: 'flex',
        borderRadius: 'inherit',
        paddingRight: '8px',
      }}
      handleComponent={{
        right: (
          <Box
            position="relative"
            right="-5px"
            height="full"
            // Library has a wrapper around element that has its own hover, this gives priority to our hover animation
            zIndex="banner"
            width={isResizing ? '2px' : '1px'}
            backgroundColor={isResizing ? 'border.dark' : 'border.light'}
            transition="background-color 200ms ease-in, width 100ms ease-in"
            _hover={{
              backgroundColor: 'border.dark',
              width: '2px',
            }}
          />
        ),
      }}
    >
      <FilterSectionContent />
    </Resizable>
  );
};

export default observer(FilterSection);
